import React from 'react';
import { Skeleton } from '@progress/kendo-react-indicators';
import HBox from '../../layout/container/h_box/HBox';
import { ROW_SKELETON_PROPS, SKELETON_DATA } from './Types';

class RowSkeleton extends React.PureComponent<ROW_SKELETON_PROPS> {
  private config = {
    actions: {
      className: 'tp-actions-cell-skeleton',
      shape: 'rectangle'
    },
    button: {
      className: 'tp-button-cell-skeleton',
      shape: 'rectangle'
    },
    checkbox: {
      className: 'tp-checkbox-cell-skeleton',
      shape: 'rectangle'
    },
    count: {
      className: 'tp-count-cell-skeleton',
      shape: 'rectangle'
    },
    icon: {
      className: 'tp-icon-cell-skeleton',
      shape: 'circle'
    },
    tag: {
      className: 'tp-tag-cell-skeleton',
      shape: 'rectangle'
    },
    text: {
      className: 'k-flex-1'
    }
  }

  private renderSkeleton = ({ height, type, width }: SKELETON_DATA, index: number) => {
    const {
      className,
      htmlTag
    } = this.props;
    const { config } = this;
    const skeleton = (
      <HBox
        className={className}
        justifyContentCenter
        style={{
          height,
          maxWidth: width
        }}
      >
        <Skeleton
          {...(config[type] || config.text)}
        />
      </HBox>
    );
    let returnValue = skeleton;

    if (htmlTag === 'td') {
      returnValue = (
        <td>
          {skeleton}
        </td>
      );
    }

    return (
      <React.Fragment key={index}>
        {returnValue}
      </React.Fragment>
    );
  };

  render() {
    return this.props.data.map(this.renderSkeleton);
  }
}

export default RowSkeleton;
